import React from 'react';
import PropTypes from 'prop-types';
import {FmlxTooltip, FmlxIcon} from 'fmlx-common-ui';
import TaskNumber from 'contents/ProtocolEditor/Components/TaskNumber';
import '../../Task.scss';
import Spinner from 'components/Spinner/Spinner';
import TaskExecutedTick from 'components/TaskExecutedTick';
import TaskWrapper from 'contents/ProtocolEditor/TaskList/Task/Components/TaskWrapper';
import TaskTitle from 'contents/ProtocolEditor/TaskList/Task/Components/TaskTitle';
import TaskAction from 'contents/ProtocolEditor/TaskList/Task/Components/TaskAction';
import {ExecutionStatus} from 'constants/dataEnum';
import {useDispatch, useSelector} from 'react-redux';
import {onSimpleTransferReuseTipsChange} from 'stores/business/taskListBusinessAction';
import {showReuseTipsModal} from 'stores/business/modalStateBusinessAction';
import {globalAddUndoItem} from 'stores/business/undoRedoBusinessAction';

import FastSwitch from 'components/Switch/FastSwitch';
import {selectOpenedProtocolIsEjectToCaddy} from 'stores/selectors/protocolSelectors';
import TaskEjectTipDescription from './TaskDescription/TaskEjectTipDescription';

function TaskEjectTip({
  // #region common props
  task,
  runtimeMode,
  readOnly,
  executionStatus,
  onDelete,
  onCheckedChange,
  // #endregion common props
  // #region dragging business
  onDrag,
  isDragging,
  disableDrag,
  // #endRegion dragging business
  isMoreThanTipCapacity,
}) {
  const {ID, number, rowTipCount, columnTipCount, isSelected, isIgnored, changeTip} = task || {};
  const dispatch = useDispatch();
  const isEjectToCaddy = useSelector(selectOpenedProtocolIsEjectToCaddy);

  const onReuseTipsChange = (checked) => {
    const reuseTipsHandler = (isChecked) => {
      dispatch(onSimpleTransferReuseTipsChange(isChecked));
      dispatch(globalAddUndoItem());
    };

    if (changeTip) {
      dispatch(showReuseTipsModal(() => reuseTipsHandler(checked), {isEnabledCase: false}));
    } else {
      reuseTipsHandler(checked);
    }
  };

  return (
    <TaskWrapper disableDrag={disableDrag} onDrag={onDrag} isDragging={isDragging} isSelected={isSelected}>
      <TaskNumber number={number} isHighlighted={isSelected} />
      <TaskTitle
        title="Eject tip(s)"
        description={
          <TaskEjectTipDescription
            rowTipCount={rowTipCount}
            columnTipCount={columnTipCount}
            showCaddyNumber={isEjectToCaddy}
            caddyNumber={task.labwareID}
          />
        }
      />
      {!runtimeMode && !readOnly && (
        <TaskAction
          onDelete={onDelete}
          isIgnored={isIgnored}
          onIgnoreCheckboxChanged={(val) => onCheckedChange(ID, val)}
        />
      )}
      {isMoreThanTipCapacity && !runtimeMode && (
        <div
          className="task-reuse-tips"
          role="presentation"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span>Eject every transfer</span>
          &nbsp;
          <FmlxTooltip title="Eject tips every transfer">
            <span>
              <FmlxIcon name="InfoOutline" size="xs" customColor="#414141" />
            </span>
          </FmlxTooltip>
          &nbsp;
          <FastSwitch size="thin" checked={changeTip} onChange={onReuseTipsChange} disabled={readOnly} />
        </div>
      )}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTING && <Spinner />}
      {runtimeMode && executionStatus === ExecutionStatus.EXECUTED && <TaskExecutedTick />}
    </TaskWrapper>
  );
}

TaskEjectTip.propTypes = {
  runtimeMode: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool.isRequired,
  executionStatus: PropTypes.string.isRequired,
  onDrag: PropTypes.func.isRequired,
  disableDrag: PropTypes.bool.isRequired,
  isDragging: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onCheckedChange: PropTypes.func.isRequired,
  task: PropTypes.object.isRequired,
  isMoreThanTipCapacity: PropTypes.bool.isRequired,
};

export default TaskEjectTip;
